import { Sort } from '@/types/sort.type';
import { CsvExportSelectionScope, dedupeCsvExportIds } from '@/components/action-buttons/csv-export-selection-scope';

type BuildReviewsCsvDownloadQueryArgs = {
    filtersQuery: string[];
    sort: Sort;
    selectionScope: CsvExportSelectionScope;
    exportOperationId: string;
};

type BuildProductsCsvDownloadQueryArgs = {
    selectionScope: CsvExportSelectionScope;
    exportOperationId: string;
};

type BuildBrandsCsvDownloadQueryArgs = {
    pickedBrandGroups: string[];
    exportOperationId: string;
};

export const buildReviewsCsvDownloadQuery = ({
    filtersQuery,
    sort,
    selectionScope,
    exportOperationId,
}: BuildReviewsCsvDownloadQueryArgs) => ({
    search: filtersQuery.filter((entry) => entry.split(':', 1)[0]?.trim().toLowerCase() !== 'platform'),
    ...sort,
    reviewFeedItemIds: selectionScope.selectedIds,
    selectionSessionId: selectionScope.selectionSessionId,
    exportOperationId,
});

export const buildProductsCsvDownloadQuery = ({
    selectionScope,
    exportOperationId,
}: BuildProductsCsvDownloadQueryArgs) => ({
    productIds: selectionScope.selectedIds,
    selectionSessionId: selectionScope.selectionSessionId,
    exportOperationId,
});

export const buildBrandsCsvDownloadQuery = ({
    pickedBrandGroups,
    exportOperationId,
}: BuildBrandsCsvDownloadQueryArgs) => {
    const brandGroupIds = dedupeCsvExportIds(pickedBrandGroups);

    return {
        brandGroupIds: brandGroupIds.length ? brandGroupIds : undefined,
        exportOperationId,
    };
};
